import React from "react";
import ScrollToTop from "react-scroll-to-top";
import Preloader from  "../helper/Preloader";
import BreadcrumbImage from  "../components/BreadcrumbImage";
import WhyBecomeSeller from  "../components/WhyBecomeSeller";
import StepsSection from  "../components/StepsSection";
import ShippingOne from  "../components/ShippingOne";
 import BottomFooter from  "../components/BottomFooter";
import HeaderFooter from  "../componentsAmazon/HeaderFooter";
import FooterOne from  "../components/FooterOne";

const FooterRulesPolicy = () => {
  
  return ( 
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#FA6400' />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */} 
      <HeaderFooter/>
 

      {/* BreadcrumbImage */}
      <BreadcrumbImage />

      {/* WhyBecomeSeller */}
      <WhyBecomeSeller />
 
      {/* StepsSection */}
      <StepsSection />
 
      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default FooterRulesPolicy;
